import BrandMark from "@/components/BrandMark";

const SITE = "forwardexspansionsolutions.com";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#05070A] pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-1 h-8 bg-amber-500 rounded-sm" />
              <BrandMark />
            </div>
            <p className="text-sm leading-relaxed text-zinc-500 max-w-sm">
              Independent commercial finance brokerage. We run auctions, not applications — 30+
              institutional lenders bidding for your business.
            </p>
            <a
              href={`https://${SITE}`}
              data-testid="footer-site-link"
              className="mt-4 inline-block text-xs font-mono-d tracking-[0.15em] text-amber-400/80 hover:text-amber-400 transition-colors"
            >
              {SITE}
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs font-mono-d tracking-[0.2em] uppercase text-zinc-500 mb-4">Navigate</p>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li><a href="#structure" className="hover:text-amber-400 transition-colors">MCA Structure</a></li>
              <li><a href="#broker-advantage" className="hover:text-amber-400 transition-colors">Broker Advantage</a></li>
              <li><a href="#pre-approval" className="hover:text-amber-400 transition-colors">Pre-Approval</a></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs font-mono-d tracking-[0.2em] uppercase text-zinc-500 mb-4">Security</p>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li>256-bit TLS encryption</li>
              <li>SOC 2 aligned document storage</li>
              <li>No hard credit inquiries</li>
            </ul>
          </div>
        </div>

        <p className="font-display font-extralight text-[6vw] leading-none text-outline text-center select-none tracking-tight whitespace-nowrap" data-testid="footer-wordmark">
          FORWARD EXSPANSION
        </p>

        <div className="mt-16 pt-8 border-t border-white/10 space-y-4">
          <p className="text-xs leading-relaxed text-zinc-600 max-w-4xl">
            Forward Exspansion Solutions is a commercial finance brokerage, not a lender. A merchant cash advance is a
            purchase of future accounts receivable and is not a loan; it is not subject to usury laws
            and does not carry an APR. All funding decisions, factor rates, and terms are made solely
            by third-party funding partners. Pre-approval is conditional and does not guarantee funding.
            Products are available to business entities only.
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-zinc-600">© {new Date().getFullYear()} Forward Exspansion Solutions · {SITE}. All rights reserved.</p>
            <a href="/admin" data-testid="footer-admin-link" className="text-xs font-mono-d tracking-[0.15em] uppercase text-zinc-600 hover:text-amber-400 transition-colors">
              Underwriting Portal
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
